import { render } from "./HeaderSection.vue?vue&type=template&id=6b0255fc&scoped=true&ts=true"
import script from "./HeaderSection.vue?vue&type=script&lang=ts"
export * from "./HeaderSection.vue?vue&type=script&lang=ts"

import "./HeaderSection.vue?vue&type=style&index=0&id=6b0255fc&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0255fc"]])

export default __exports__